<template>
    <teleport v-if="fixed" to="body">
        <footer class="aic-footer aic-footer--fixed border-top shadow-sm navbar-light bg-light">
            <div class="aic-footer__content text-dark text-center small">
                Powered by | <strong>Proba Workflows</strong>
            </div>
        </footer>
    </teleport>
    <footer v-else class="aic-footer aic-footer--inline border-top shadow-sm navbar-light bg-light">
        <div class="aic-footer__content text-dark text-center small">
            Powered by | <strong>Proba Workflows</strong>
        </div>
    </footer>
</template>

<script>
    export default {
        name: 'AiFooter',
        props: {
            fixed: {
                type: Boolean,
                default: true,
            },
        },
    }
</script>

<style scoped>
:global(body) {
    padding-bottom: calc(56px + constant(safe-area-inset-bottom));
    padding-bottom: calc(56px + env(safe-area-inset-bottom, 0px));
}

.aic-footer {
    width: 100%;
    min-height: calc(56px + constant(safe-area-inset-bottom));
    min-height: calc(56px + env(safe-area-inset-bottom, 0px));
    background-color: var(--bs-light, #f8f9fa) !important;
    box-sizing: border-box;
}

.aic-footer--fixed {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2000;
}

.aic-footer--inline {
    position: relative;
    z-index: 1;
}

.aic-footer__content {
    min-height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.75rem 1rem calc(0.75rem + constant(safe-area-inset-bottom));
    padding: 0.75rem 1rem calc(0.75rem + env(safe-area-inset-bottom, 0px));
}
</style>